import PropTypes from "prop-types"
import React from "react"

import { BodyText } from "../../../../Typography/Typography"

import { townLabel } from "./styles.module.scss"

function TownLabel({ town }) {
  return (
    <BodyText light semibold className={townLabel}>
      {town}
    </BodyText>
  )
}

TownLabel.propTypes = {
  town: PropTypes.string.isRequired,
}

export default TownLabel
